import {useState, useEffect} from 'react';
import api from "../../api/api";
import './ReplicationDot.css'

const ReplicationDot = () => {
    const [isHealthy, setIsHealthy] = useState(null);

    const checkStatus = async () => {
        try {
            const {data} = await api().get('/replication-simple', {
                timeout: 4000,
            });
            setIsHealthy(data.is_healthy);
        } catch {
            setIsHealthy(false);
        }
    };

    useEffect(() => {
        checkStatus();
        const interval = setInterval(checkStatus, 10000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{display: isHealthy === null && 'none'}}
             className={`replication-dot ${isHealthy ? 'green' : 'red'}`}
             title={isHealthy ? "Репликация работает" : "Проблема с репликацией"}
        >
            Replication
        </div>
    );
};

export default ReplicationDot;